const TONES = {
  success:  'bg-success-tint text-success',
  caution:  'bg-caution-tint text-caution',
  critical: 'bg-critical-tint text-critical',
  info:     'bg-transit-tint text-transit-deep',
  neutral:  'bg-line-soft text-ink-soft',
};

export default function Badge({ tone = 'neutral', children }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-bold px-2.5 py-1 rounded-full font-body ${TONES[tone] || TONES.neutral}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {children}
    </span>
  );
}
